import ViewBase from "../../view-base.view";
import MultiSelectComponent from '../../../components/multi-select/multi-select.component';
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import scheduleModel from "../../../models/schedule/jpo-schedule.model";
import { codeMasterType } from "../../../config/constants";
import scheduleManualTriggerModel from "../../../models/schedule/schedule-manual-trigger.model";
import paginationComponent from "../../../components/pagination/pagination.component";
import { Button, Checkbox, Icons, Intent } from "construct-ui";
import SelectUserComponent from "../../../components/user/select-user.component";



export default function JPOManualTriggerView() {
    ViewBase.call(this);

    let imceTypeList = [];
    let userRoleList = [];
    let userRoleListByFilter = [];
    let supervisorList = [];
    let supervisorListByFilter = [];
    let adminList = [];
    let tableData = [];

    let imceTypeOld = '';
    let isSubsidiaryAdmin = false;
    let isLoading = false;
    let isAllChecked = false;

    let statusInterval;

    const DEFAULT_PAGINATION = {
        pageIndex: 1,
        pageSize: 10,
        total: 0
    };

    const DEFAULT_FILTERS = {
        selectedUsers: [],
        imceType: {},
        userRole: {},
        supervisors: [],
    };
    let filters = structuredClone(DEFAULT_FILTERS);
    let pagination = structuredClone(DEFAULT_PAGINATION);

    let search = () => {
        this.showLoading();
        clearInterval(statusInterval);
        isLoading = true;
        scheduleManualTriggerModel.getUsers({
            UserIDs: filters.selectedUsers.map(i => i.userID).join('^'),
            BU: filters.imceType.code,
            SupervisorRoles: filters.userRole.code,
            SupervisorIds: filters.supervisors.map(i => i["code"]).join('^'),
            PageIndex: pagination.pageIndex,
            PageSize: pagination.pageSize
        }).then((result) => {
            (result.data || []).forEach(e => {
                e.message = '';
                e.createDate = '';
                e.isChecked = false;
                e.statusType = 999;
            });
            tableData = result.data;
            pagination.total = result.total;
            getJpoStatus();
        })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading()
                isLoading = false;
            });

    }
    let getJpoStatus = () => {
        if (tableData == null || tableData.length == 0) {
            return;
        }
        var filter = {
            userIds: tableData.map(d => d.userId).join("^"),
            scheduleMonth: ""
        };
        scheduleManualTriggerModel.getJPOStatus(filter)
            .then((result) => {
                result = result || [];

                (tableData || []).forEach(e => {
                    var r = result.filter(x => x.userId == e.userId);
                    e.isChecked = false;
                    if (r.length == 0) {
                        e.message = '';
                        e.createDate = '';
                        e.statusType = 999;
                    } else {
                        e.message = r[0].message;
                        e.createDate = r[0].createDate;
                        e.statusType = r[0].type;
                    }
                });
                if (result.filter(r => r.type == 0).length == 0) {
                    clearInterval(statusInterval);
                }
            }).catch((error) => {
                this.handleError(error);
            })
    }
    const onCheckAll = () => {
        isAllChecked = !isAllChecked;
        (tableData || []).forEach(e => {
            if (e.statusType != 0) {
                e.isChecked = isAllChecked;
            }

        });
    }
    const onCheck = (data) => {
        data.isChecked = !data.isChecked;
        var c1 = tableData.filter(d => d.statusType != 0);
        var c2 = tableData.filter(d => d.statusType != 0 && d.isChecked);
        if (c1.length != 0) {
            isAllChecked = c1.length == c2.length;
        }
    }
    const onGenerate = () => {
        var dcheck = tableData.filter(d => d.statusType != 0 && d.isChecked);
        if (dcheck.length == 0) {
            return;
        }
        this.showLoading();
        var data = {
            userIds: dcheck.map(d => d.userId).join("^"),
            scheduleMonth: ""
        };
        scheduleManualTriggerModel.queue(data)
            .then((result) => {
                isAllChecked = false;
                clearInterval(statusInterval);
                if (result != null && result.code == "EM00000004") {
                    getJpoStatus();
                    statusInterval = setInterval(getJpoStatus, 1000 * 10);
                }
            }).catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.hideLoading()
                isLoading = false;
            });
    }
    const onSearch = () => {
        search();
    }
    let onClear = () => {
        filters.imceType = imceTypeList.length > 0 ? imceTypeList[0] : {};
        imceTypeOld = filters.imceType.code;
        filters.supervisors = [];
        filters.selectedUsers = [];
        getUserRoleListByFilter();
        search();
    }

    let getUserRoleListByFilter = () => {
        userRoleListByFilter = [];
        if (userRoleList) {
            userRoleListByFilter = userRoleList.filter(x => x.mapData == filters.imceType.code);
            if (userRoleListByFilter.length > 0) {
                filters.userRole = userRoleListByFilter[0];
                if (isLoading) {
                    getSupervisorList();
                } else {
                    getSupervisorListByFilter();
                }
            }
        } else {
            getUserRoleList();
        }
    }
    const onPageSizeChanged = (_, pageSize) => {
        pagination.pageSize = pageSize;
        search();
    }
    const onPageChanged = (pageIndex) => {
        pagination.pageIndex = pageIndex;
        search();
    }
    let getUserRoleList = () => {
        userRoleList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        userRoleList.push({ ...e });
                    });
                    getUserRoleListByFilter();
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: 'SupervisorRole',
            }
        )
    }
    let getSupervisorList = () => {
        supervisorList = [];
        this.showLoading();

        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        supervisorList.push({ ...e });
                    });
                }
                getSupervisorListByFilter();
                this.hideLoading();
            },
            (error) => {
                this.handleError(error);
                this.hideLoading();
            },
            {
                type: 'SupervisorOrLeadSupervisor',
                mapData: userRoleList.map(i => i["code"]).join(',')
            }
        );
    }

    let getSupervisorListByFilter = () => {
        supervisorListByFilter = [];
        filters.supervisors = [];
        if (supervisorList) {
            supervisorListByFilter = supervisorList.filter(x => x.mapData == filters.userRole.code);
            if (isLoading) {
                isLoading = false;
                search();
            }
        } else {
            getSupervisorList();
        }
    }
    const getImceTypeList = () => {
        imceTypeList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    imceTypeList = result;
                    filters.imceType = imceTypeList.length > 0 ? imceTypeList[0] : {};
                    imceTypeOld = filters.imceType.code;
                    getUserRoleList();
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: codeMasterType.bu,
            }
        )
    }
    let getAdmin = () => {
        adminList = [];
        scheduleModel.getSchedulePlanAndActualCodeMaster(
            (result) => {
                if (result) {
                    result.forEach(e => {
                        adminList.push({ ...e });
                    });
                    // isAdmin = adminList.filter(x => x.code == 'Admin' && x.mapData == 1).length > 0;
                    isSubsidiaryAdmin = adminList.filter(x => x.code == 'SubsidiaryAdmin' && x.mapData == 1).length > 0;
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                type: 'SummaryRptAdmin',
            }
        )
    }

    return {
        oninit: ({ attrs }) => {
            isLoading = true;
            getAdmin();
            getImceTypeList();
        },
        oncreate: (vnode) => {

        },
        onremove: (vnode) => {
            clearInterval(statusInterval);
        },
        view: (vnode) => {
            return [
                m(".manual-trigger", [
                    m(".card.mb-3",
                        m(".card-body",
                            m('.row.g-4',
                                m(".col-md-3.col-lg-3.position-relative",
                                    m("label.form-label", this.getText("LT00000817", "MX/CE Store")),
                                    m(SingleSelectComponent, {
                                        id: "imce",
                                        items: imceTypeList,
                                        selectedItem: filters.imceType,
                                        checkmark: true,
                                        filterable: true,
                                        required: true,
                                        allowEmpty: false,
                                        onSelect: (s) => {
                                            if (imceTypeOld != s.code && s.code != '') {
                                                filters.imceType = s;
                                                filters.userRole = userRoleListByFilter[0];
                                                filters.supervisors = [];
                                                getUserRoleListByFilter();
                                                imceTypeOld = s.code;
                                            }
                                        },
                                    })
                                ),
                                m('.col-md-3',
                                    m('label.form-label', this.getText("LT00000060", "User Role")),
                                    m(SingleSelectComponent, {
                                        items: userRoleListByFilter,
                                        selectedItem: filters.userRole,
                                        allowEmpty: false,
                                        onSelect: (s) => {
                                            filters.userRole = s;
                                            getSupervisorListByFilter();
                                        }
                                    }),
                                ),
                                m('.col-md-3',
                                    m('label.form-label', this.getText(isSubsidiaryAdmin ? "LT00008108" : "LT00000271", isSubsidiaryAdmin == 1 ? "Lead Supervisor" : "Supervisor")),
                                    m(MultiSelectComponent, {
                                        items: supervisorListByFilter,
                                        selectedItems: filters.supervisors,
                                        onSelect: (s) => {
                                            filters.supervisors = s;
                                        }
                                    }),
                                ),
                                m('.col-md-3',
                                    m('label.form-label', this.getText("LT00000009", "User")),
                                    m(SelectUserComponent, {
                                        default: {
                                            userStatusCode: '0001'
                                        },
                                        onSelect: (u) => {
                                            filters.selectedUsers = u;
                                        },
                                        getRoleFilter: (e) => {
                                            return [filters.userRole];
                                        },
                                        selectedUserList: filters.selectedUsers,
                                        hideMyTeam: true,
                                        hideUploadUsers: true
                                    })
                                ),
                                m(".col-12.gap-2.d-flex.justify-content-end",
                                    m('button.btn.btn-primary', { onclick: onSearch }, this.getText("LT00000001", "Search")),

                                    m('button.btn.btn-white', { onclick: onClear }, this.getText("LT00000031", "Clear")),
                                )

                            )
                        )
                    ),
                    m('.card',
                        m('.card-body',
                            m('.row.g-2 ',
                                m('.col-12.p-0',
                                    m('.d-flex.flex-row-reverse.pb-2',

                                        m(Button, {
                                            style: { "margin-right": '10px' },
                                            label: this.getText("LT00008164", "Generate"),
                                            intent: Intent.POSITIVE,
                                            iconLeft: Icons.SETTINGS,
                                            onclick: onGenerate
                                        })

                                    ),
                                    m('.table-responsive',
                                        m('table.table.table-hover',
                                            m('thead.thead-bggrey', m('tr.align-middle',
                                                m("th", { style: "width: 50px;" }, m(Checkbox, {
                                                    checked: isAllChecked,
                                                    onchange: onCheckAll
                                                })),
                                                m("th", this.getText("LT00000271", "Supervisor")),
                                                m("th", this.getText("LT00008162", "Last Status")),
                                                m("th", { style: "width: 150px;" }, this.getText("LT00008163", "Last Status Date"))
                                            )
                                            ),
                                            m('tbody',

                                                (tableData == null || tableData.length == 0) &&
                                                m('tr.align-middle',
                                                    m('td[colSpan=4]', this.getText("EM00000141", "No records found."))
                                                ),

                                                tableData != null &&
                                                tableData.map((data, index) =>
                                                    m('tr',
                                                        m("td", m(Checkbox, {
                                                            checked: data.isChecked,
                                                            onchange: () => onCheck(data),
                                                            disabled: data.statusType == 0
                                                        })),
                                                        m("td", m("span", `${data.userName} (${data.userId})`)),
                                                        m("td", m("span", data.message)),
                                                        m("td", m("span", data.createDate))
                                                    )
                                                )
                                            )
                                        )
                                    ),
                                    !isLoading &&
                                    m(".px-3 pt-2 pg-ctr",
                                        m(paginationComponent, { currentPage: pagination.pageIndex, pageSize: pagination.pageSize, totalItems: pagination.total, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                                    )

                                )
                            )
                        )
                    )
                ]),
                this.getBaseViews()
            ]
        }

    }

}

